import { render, staticRenderFns } from "./LandForSale.vue?vue&type=template&id=fe911222&scoped=true&"
import script from "./LandForSale.vue?vue&type=script&lang=ts&"
export * from "./LandForSale.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe911222",
  null
  
)

export default component.exports